  import React from 'react';
  import * as styles from './Pagination.css';
  import { Icon } from 'icons';
  type PaginationProps = {
      total: number;
      pageSize: number;
      current: number;
      onChange: (page: number) => void;
      className?: string;
  }

  const Pagination = ({ total, pageSize, current, onChange, className }: PaginationProps) => {
    const totalPages = Math.ceil(total / pageSize);
    // 페이지 번호 배열 생성
    const getPageNumbers = () => {
      const pages = [];
      const maxVisiblePages = 5;
      
      if (totalPages <= maxVisiblePages) {
        // 전체 페이지가 5개 이하면 모두 표시
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        // 현재 페이지 주변의 페이지들 표시
        let startPage = Math.max(1, current - 2);
        let endPage = Math.min(totalPages, current + 2);
        
        if (current <= 3) {
          endPage = Math.min(totalPages, 5);
        } else if (current >= totalPages - 2) {
          startPage = Math.max(1, totalPages - 4);
        }
        
        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }
      }
      
      return pages;
    };

    const handlePageChange = (page: number) => {
      if (page >= 1 && page <= totalPages && page !== current) {
        onChange(page);
      }
    };

    const handlePrevPage = () => {
      if (current > 1) {
        onChange(current - 1);
      }
    };

    const handleNextPage = () => {
      if (current < totalPages) {
        onChange(current + 1);
      }
    };

    if (totalPages <= 0) return null;

      return (
      <ul className={`${styles.pagination} ${className}`}>
        {/* 이전 페이지 화살표 */}
        <li 
          className={`${styles.paginationArrow} ${current === 1 ? styles.paginationArrowDisabled : ''}`}
          onClick={handlePrevPage}
        >
          <Icon 
            name='arrowDown' 
            style={{
              transform: 'rotate(90deg)',
              filter: 'invert(50%)'
            }} 
          />
        </li>
        
        {/* 페이지 번호들 */}
        {getPageNumbers().map((page) => (
          <li 
            key={page}
            className={`${styles.paginationItem} ${current === page ? styles.paginationItemActive : ''}`}
            onClick={() => handlePageChange(page)}
          >
            {page}
          </li>
        ))}
        
        {/* 다음 페이지 화살표 */}
        <li 
          className={`${styles.paginationArrow} ${current === totalPages ? styles.paginationArrowDisabled : ''}`}
          onClick={handleNextPage}
        >
          <Icon 
            name='arrowDown' 
            style={{
              transform: 'rotate(270deg)',
              filter: 'invert(50%)'
            }} 
          />
        </li>
      </ul>
    );
  };

  export default Pagination;